module.exports = __webpack_public_path__ + "img/phone.ab64ef2a.svg";